import request from './request'

// 平台配置列表
export function getPlatformConfigs(params) {
  return request({
    url: '/admin/platform-configs',
    method: 'get',
    params
  })
}

// 按 config_key 更新配置值
export function updatePlatformConfig(key, data) {
  return request({
    url: `/admin/platform-configs/${key}`,
    method: 'put',
    data
  })
}
